<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import TourEditModal from "./TourEditModal.svelte";

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE TOUR', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        // {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        // {key: 'login_at', title: 'LOGIN', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    let tours = null;
    let editId = null;
    let tourId = null;


    const load = () => {
        const onSuccess = result => {
            tours = result;
        }

        const onFailure = err => {
        };

        R.handle(R.tour.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail}) => {
        tours = sort(tours, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (item) => {
        tourId = item.id;
        editId = item.id;
    }

    const onUpdate = () => {
        load();
    }

    // const closeEdit = (param) => {
    //     if (param) {
    //         load();
    //     }
    //     editId = null;
    // }

    const closeEdit = () => {
        editId = null;
    }

    const onDelete = (item) => {
        Alert.delete("Delete tour", `This will permanently delete tour "${item.name}".\nAre you sure?`, () => deleteTour(item.id));
    }

    const deleteTour = id => {
        const onSuccess = result => {
            tours = users.filter(x => x.id != result);
            Notifier.showMessage("Tour deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                let message = [];
                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });
                Alert.warning("Delete tour", `Tour is related to ${message.join(", ")}.\nYou can not delete this tour.`);
            }
        };

        R.handle(R.tour.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>
<PageHeader title="Tours" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if tours}
    <div class="panel">
        <div class="panel-body">
            {#if tours.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each tours as item}
                        <tr class="row-hover" class:row-selected="{ tourId === item.id }">
                            <td>
                                <span class="is-link" class:not-active="{ item.is_active < 1 }"
                                      on:click="{ () => onEdit(item) }">
                                    { item.name }
                                </span>
                            </td>
                            <td class="button-column pointer" title="delete tour" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
                {:else}
                <div class="panel-simple panel-pad">
                    No tours found!
                </div>
            {/if}
        </div>
    </div>
{/if}
{#if editId != null}
    <TourEditModal tourId="{ editId }" updateCallback="{ onUpdate }" closeCallback="{ closeEdit }"/>
{/if}